/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "Reality.Reality.Api";

export interface AgencyEventRankingGroup {
  eventId: number;
  groupId: number;
  rank: number;
  groupName: string;
  score: number;
}

function createBaseAgencyEventRankingGroup(): AgencyEventRankingGroup {
  return { eventId: 0, groupId: 0, rank: 0, groupName: "", score: 0 };
}

export const AgencyEventRankingGroup = {
  encode(message: AgencyEventRankingGroup, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.eventId !== 0) {
      writer.uint32(8).int64(message.eventId);
    }
    if (message.groupId !== 0) {
      writer.uint32(16).int64(message.groupId);
    }
    if (message.rank !== 0) {
      writer.uint32(24).int64(message.rank);
    }
    if (message.groupName !== "") {
      writer.uint32(34).string(message.groupName);
    }
    if (message.score !== 0) {
      writer.uint32(40).int64(message.score);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgencyEventRankingGroup {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgencyEventRankingGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.eventId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.groupId = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.rank = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.groupName = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.score = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgencyEventRankingGroup {
    return {
      eventId: isSet(object.eventId) ? globalThis.Number(object.eventId) : 0,
      groupId: isSet(object.groupId) ? globalThis.Number(object.groupId) : 0,
      rank: isSet(object.rank) ? globalThis.Number(object.rank) : 0,
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : "",
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
    };
  },

  toJSON(message: AgencyEventRankingGroup): unknown {
    const obj: any = {};
    if (message.eventId !== 0) {
      obj.eventId = Math.round(message.eventId);
    }
    if (message.groupId !== 0) {
      obj.groupId = Math.round(message.groupId);
    }
    if (message.rank !== 0) {
      obj.rank = Math.round(message.rank);
    }
    if (message.groupName !== "") {
      obj.groupName = message.groupName;
    }
    if (message.score !== 0) {
      obj.score = Math.round(message.score);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgencyEventRankingGroup>, I>>(base?: I): AgencyEventRankingGroup {
    return AgencyEventRankingGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgencyEventRankingGroup>, I>>(object: I): AgencyEventRankingGroup {
    const message = createBaseAgencyEventRankingGroup();
    message.eventId = object.eventId ?? 0;
    message.groupId = object.groupId ?? 0;
    message.rank = object.rank ?? 0;
    message.groupName = object.groupName ?? "";
    message.score = object.score ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
